import React from 'react';

import Form from '../components/form/form';

const Details = (Screen, Data, ShowPopup, saveAction, closeAction, forgotAction, changeAction, beforeSaveAction, parentVal) => <Form showPopup={ShowPopup} screen={Screen} data={Data} beforeSaveAction={beforeSaveAction} saveAction={saveAction} closeAction={closeAction} forgotAction={forgotAction} changeAction={changeAction} parentVal={parentVal} />;

export default Details;